<script lang="ts">
  import { TabContent } from 'carbon-components-svelte';

  import AffectedSlaClients from './AffectedSlaClients.svelte';
  import AuditTable from '../../../components/audit-table/AuditTable.svelte';
  import LazyLoadedTabContent from '../../../components/LazyLoadedTabContent.svelte';
  import SlaExecutionHistory from './SlaExecutionHistory.svelte';
  import SlaBasicInformation from './SlaBasicInformation.svelte';
  import TabsWithRouting from '../../../components/TabsWithRouting.svelte';

  export let slaTaskId: string;
</script>

<TabsWithRouting
  defaultHash="#basic-information"
  tabsWrapperProps={{ 'aria-label': 'SLA Task details tabs' }}
  tabs={[
    { label: 'Basic Information', hash: '#basic-information' },
    { label: 'Affected Clients', hash: '#affected-clients' },
    { label: 'Execution History', hash: '#execution-history' },
    { label: 'History', hash: '#history' },
  ]}
>
  <TabContent><SlaBasicInformation {slaTaskId} /></TabContent>
  <LazyLoadedTabContent hash="#affected-clients"><AffectedSlaClients {slaTaskId} /></LazyLoadedTabContent>
  <LazyLoadedTabContent hash="#execution-history"><SlaExecutionHistory {slaTaskId} /></LazyLoadedTabContent>
  <LazyLoadedTabContent hash="#history"><AuditTable entityId={slaTaskId} entityType="feed-sla-task" /></LazyLoadedTabContent>
</TabsWithRouting>
